class ConstTiposNotificacionesPush
{
    PEDIDO = 1;
    STATUSTRACKING = 2;
    RECLAMACIONES = 3;
    COTIZACIONES = 4;

  get(id){
    switch (id){
      case this.PEIDDO: return "pedido";
      case this.STATUSTRACKING: return "status_tracking";
      case this.RECLAMACIONES: return "reclamacion";
      case this.COTIZACIONES: return "cotizacion";
    }
  }

  constructor(obj = {}) {
    Object.assign(this, obj);
  }
}

module.exports = ConstTiposNotificacionesPush;